var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticStyle: { height: "500px", width: "100%" },
      attrs: { id: "map" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "filters" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedType,
              expression: "selectedType",
            },
          ],
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedType = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.filterLocations,
            ],
          },
        },
        [
          _c("option", { attrs: { value: "" } }, [_vm._v("Alla")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "rundelsgatan" } }, [
            _vm._v("Rundelsgatan"),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "dockplatsen" } }, [
            _vm._v("Dockplatsen"),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "florettgatan" } }, [
            _vm._v("Florettgatan"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }